import i18n from "src/lang";
const regexObj = {
  isPositiveIntegerHasZero: /^([1-9]\d*|[0]{1,1})$/, //正整数(包括0)
  isPositiveInteger: /[^0-9]+/g,
  isInteger: /^[+]?\d*$/,
  isMobileNumber:
    /(^\+?(66)(\d{2}\-?\d{3}\-?\d{3,4})$)|(^1[3|4|5|8|7][0-9]\d{8}$)/, // 2018-11-19改需求 /^1[3|4|5|8|7][0-9]\d{8}$/
  isPhoneNumber:
    /(^\+?(66)(\d{2}\-?\d{3}\-?\d{3,4})$)|(^1[3|4|5|8|7][0-9]\d{8}$)/,
  isChineseName: /^[\u4e00-\u9fa5 ]{2,8}$/,
  isIdCardNumber:
    /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
  isFloat: /^(([1-9]\d{0,9})|0)(\.\d*)?$/,
  isNature: /^(([1-9]\d{0,9})|0)(\.\d+)?$/,
  isMoney: /^((-|\+)?)(([1-9]\d{0,9})|0)(\.\d{1,2})?$/,
  isBankCard: /^[1-9]\d*$/, //匹配首位非0正整数
  verifyCode: /^\d{6}$/,
  greaterZero: /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])$/, //大于0的浮点数
  positiveIntegerZero: /^\+?[1-9]\d*$/, //大于0正整数(不包括0)
  isFloatingPointNumbersHasZero: /^\d+(\.\d+)?$/, //大于等于0的浮点数
  isTHPlateNo:
    /(^([\u0E00-\u0E7F\u00C0-\u017F\w\p{Punct}!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{1,10})$)/,
  isPlateNo:
    /(^([\u0E00-\u0E7F\w\p{Punct}!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{1,10})$)|(^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$)/,
  isEnChar: /^[A-Za-z][A-Za-z0-9]*$/,
  isNotNumber: /^[^\n0-9]{1,}$/,
  isPersonName:
    /^([\u0E00-\u0E7F\p{Alpha}\p{Punct}\u00C0-\u017F\x00-\x7F ]{0,30})$/,
  isNonDigitDriverName: /^\D{1,30}$/,
  isNumber: /^[0-9]+$/,
  isTwoDigitsNumber: /^[0-9]{2}$/,
};

var validLabelObj = {
  siteSubTypeId: "Site Sub - Type",
  companyTaxId: "Company Tax ID",
  companyPhoneNumber: "The Company Phone No",
  bankAccountNumber: "The Account Number",
  keyContactPhoneNumber: "The Mobile Phone No",
  keyContactLandlineNumber: "The Landline Phone No",
  keyContactFirstName: "First Name",
  keyContactLastName: "Last Name",
  keyContactEmail: "The Email",
  keyContactLandlineExtension: "The Extension",
  siteCode: "The Site Code",
  siteName: "The Site Name",
  siteShortName: "The Site Short Name",
  address: "The Address",
  provinceId: "The Province",
  bankAccountName: "The Bank Account Name",
  tmsBankInfoId: "The Bank Name",
  districtId: "The District",
  subDistrictId: "The Sub-District",
  subDistrict: "Sub-District",
  postalCode: "The Postal Code",
  customerId: "The Customer Name",
  driverLicenseNumber: "Driver License Number",
  nationalIdCardNumber: "National ID Card Number",
  companyRegisteredName: "The Company Registered Name",
  companyNameTH: "The Company Name/Individual Name (TH)",
  keyContactPhoneNumber: "The Mobile Phone No.",
  contactNumber: "Contact Number",
  nationalIdCardExpiredDate: "The Expired Date",
  driverLicenseIssueDate: "The Issue Date",
  issueDateOfCompulsoryThirdPartyInsurance: "Issued Date",
  expireDateOfCompulsoryThirdPartyInsurance: "Expired Date",
  driverLicenseExpiredDate: "The Expired Date",
  driverNameTitle: "The Title",
  driverFirstName: "First Name",
  driverLastName: "Last Name",
  lat: "The Latitude",
  lng: "The Longitude",
  vehicleBrandOption: "The Vehicle Brand: Additional detail",
  landlinePhoneExtension: "The Extension",
  latestDeliveryDt: "The latest Delivery Dt field",
  latestReceivedDt: "The latest Received Dt field",
  vehicleWidth: "Vehicle Width (m)",
  vehicleLength: "Vehicle Length (m)",
  vehicleHeight: "Vehicle Height (m)",
  vehicleMaxWeight: "Vehicle Max Weight (Ton)",
  trailerMaxWeight: "Trailer Max Weight (Ton)",
  trailerWidth: "Trailer Width (m)",
  trailerLength: "Trailer Length (m)",
  trailerHeight: "Trailer Height (m)",
  trailerMaxVolume: "Trailer Max Volume (m3)",
  partner: "The Partner field",
  // weight: "The Weight field",
  packingQty: "The PackingQty field",
  selectedTemperatureStandard: "The Selected Temperature Standard field",
  senderMobile: "The Sender Mobile field",
  receiverMobile: "The Receiver Mobile field",
  receiverAddress: "The Receiver Address field",
  senderAddress: "The Sender Address field",
  routeCode: i18n.t("business.routeCode"),
  actualTotalNoPackReceived: i18n.t(
    "business.actualTotalNumberOfPackagesReceived"
  ),
  actualTotalNoPackPaid: i18n.t("business.actualTotalNumberOfPackagesPaid"),
  unitTotalNoPackPaid: i18n.t("toolTip.unit"),
  unitTotalNoPackReceived: i18n.t("toolTip.unit"),
  paidByVehicleTypeText: i18n.t("public.reason"),
  paidByVehicleType: i18n.t("business.paidByVehicleType"),
  actualVehicleTypeReason: "Reason",
  code: i18n.t("serviceItem.itemCode"),
  itemCode: i18n.t("serviceItem.itemCode"),
  provider: i18n.t("capacityPool.partnerName"),
  serviceName: i18n.t("serviceItem.itemName"),
  itemName: i18n.t("serviceItem.itemName"),
  shortName: i18n.t("public.shortName"),
  choseNode: i18n.t("serviceItem.step"),
  code1: i18n.t("serviceItem.itemCode"),
  actualQuantityOfGoods: i18n.t("trackingActivity.actualNoOfItemPerPackage"),
  actualQuantityOfPackages: i18n.t("trackingActivity.actualNoOfPackage"),
  insurancCoverage: "Insurance Coverage",
  policyNumber: "Policy Number",
  code: i18n.t("serviceItem.itemCode"),
  provider: i18n.t("capacityPool.partnerName"),
  serviceName: i18n.t("serviceItem.itemName"),
  choseNode: i18n.t("serviceItem.step"),
  geofencingRange: "Geofencing Area",
  cargoPolicyNumber: "Policy Number",
  cargoPurchaseFrom: "Purchase From",
  tmsInsuranceCompanyNameId: "Insurance Company Name",
  cargoEffectiveDate: "Effective Date",
  cargoEndDate: "End Date",
  cargoInsuranceCoverage: "Insurance Coverage",
  cargoInsuredNameUnder: "Insured Name Under",
  cargoCompanyName: "Company Name",
  cargoTitle: "Title",
  cargoFirstName: "First Name",
  cargoLastName: "Last Name",
  carOwnerTitle: "Title",
  carOwnerFirstName: "First Name",
  carOwnerCompanyName: "Company Name",
  carOwnerLastName: "Last Name",
  carOwnerInsuredNameUnder: "Car Owner",
  vehiclePolicyNumber: "Policy Number",
  vehicleEffectiveDate: "Effective Date",
  vehicleEndDate: "End Date",
  vehicleVehicleInsuranceType: "Vehicle Insurance Type",
  vehicleInsuranceCoverage: "Insurance Coverage",
  vehicleInsuredNameUnder: "Insured Name Under",
  vehicleCompanyName: "Company Name",
  vehicleTitle: "Title",
  vehicleFirstName: "First Name",
  vehicleLastName: "Last Name",
  weight: i18n.t("trackingActivity.pickupWeight"),
  deliverWeight: i18n.t("trackingActivity.deliverWeight"),
  packagesQuantity: i18n.t("trackingActivity.actualNoOfPackage"),
  goodsQuantity: "Quantity of goods",
  volume: i18n.t("trackingActivity.actualVolume"),
  belongTo: i18n.t("capacityPool.partnerName"),
  lowerLimit: "Temperature Control Lower Limit",
  upperLimit: "Temperature Control Upper Limit",
  temperatureControlName: i18n.t("business.temperatureControlName"),
  temperatureControlNo: "Code",
  doRef: i18n.t("business.doRef"),
  farthestStore: i18n.t("business.farthestStoreCode"),
  contactNumberOriginToolTip: i18n.t("business.contactNumberOriginToolTip"),
  addressOriginToolTip: i18n.t("business.addressOriginToolTip"),
  latestDeliveryDt: i18n.t("business.latestDeliveryDt"),
  provinceCityDistrict: i18n.t("business.provinceCityDistrict"),
  contactNameOriginToolTip: i18n.t("business.contactNameOriginToolTip"),
  ext1: i18n.t("business.destinationType"),
  ext4: i18n.t("business.presetLine"),
  actualOrderPrice: i18n.t("public.actualOrderPrice"),
  temperature: i18n.t("trackingActivity.shipmentPickupTemperature"),
  shipmentDeliverTemperature: i18n.t(
    "trackingActivity.shipmentDeliverTemperature"
  ),
  shipmentReturnTemperature: i18n.t(
    "trackingActivity.shipmentReturnTemperature"
  ),
  damagedPackage: i18n.t("public.damagedPackage"),
  damagedQuantity: i18n.t("public.damagedItem"),
  rejectedQuantity: i18n.t("public.rejectedItem"),
  rejectedPackage: i18n.t("public.rejectedPackage"),
  bizTypeToolTip: i18n.t("business.bizType"),
};

var formatErrorMessagesDecimal = {
  weight: "The weight field must be numeric and may contain 2 decimal points.",
  packingQty:
    "The Total Number of Package field must be numeric and may contain 2 decimal points.",
  volume: "The volume field must be numeric and may contain 2 decimal points.",
  goodsQty:
    "The Total Number of item per packages field must be numeric and may contain 2 decimal points.",
  lowerLimit: "Temperature Control Lower Limit is invalid",
  upperLimit: "Temperature Control Upper Limit is invalid",
};

var formatErrorMessagesMax = {
  name: "Name",
  code: "Code",
  itemCode: i18n.t("serviceItem.itemCode"),
  itemName: i18n.t("serviceItem.itemName"),
  itemType: i18n.t("business.itemType"),
  itemNumber: i18n.t("business.goodsTypeNumber"),
  "short name": i18n.t("public.shortName"),
  shortName: i18n.t("public.shortName"),
  groupCode: i18n.t("product.groupCode"),
  groupName: i18n.t("product.groupName"),
  groupShortName: i18n.t("product.groupShortName"),
};

const formatErrorMessagesCharacter = {
  keywords: i18n.t("toolTip.keywords"),
  description: i18n.t("toolTip.description"),
};

const TYPE_REQUIRED = "require";
const TYPE_BETWEEN = "between";
const TYPE_MAX_VAL = "max_val"; // สูงสุดเท่ากับ
const TYPE_MIN_VAL = "min_val"; // ขั้นต่ำเท่ากับ
const TYPE_DECIMAL = "decimal";
const TYPE_NUMERIC = "numeric";
const TYPE_MAX_CHARACTER = "max_character";
const TYPE_FORMAT = "format";
const customThaiErrorMessage = {
  [i18n.t("business.receiptType") + TYPE_REQUIRED]:
    "ประเภทใบเสร็จรับเงิน จำเป็นต้องกรอก หากเลือกต้องการใบเสร็จรับเงิน",
  [i18n.t("business.receiptQty") + TYPE_REQUIRED]:
    "จำนวนใบเสร็จรับเงิน จำเป็นต้องกรอก หากเลือกต้องการใบเสร็จรับเงิน",
  [i18n.t("business.provinceCityDistrict") + TYPE_REQUIRED]:
    "จังหวัด เมือง อำเภอจำเป็นต้องกรอก",
  [i18n.t("business.goodsValue") + TYPE_MAX_VAL]:
    "มูลค่าประกันสินค้าสูงสุดเท่ากับ",
  [i18n.t("business.goodsValue") + TYPE_MIN_VAL]:
    "มูลค่าประกันสินค้าขั้นต่ำเท่ากับ",
  [i18n.t("business.goodsValue") + TYPE_DECIMAL]:
    "มูลค่าประกันสินค้าไม่ถูกต้อง",
  [i18n.t("business.packingWeight") + TYPE_BETWEEN]: "น้ำหนักต่อบรรจุภัณฑ์",
  [i18n.t("business.numberOfPackages") + TYPE_BETWEEN]: "จำนวนบรรจุภัณฑ์",
  [i18n.t("business.numberOfItemPerPackages") + TYPE_MAX_VAL]:
    "จำนวนสินค้าทั้งหมดต่อบรรจุภัณฑ์สูงสุดคือ",
  ["actualTotalNoPackPaid" + TYPE_NUMERIC]: "รูปแบบจำนวนจ่ายจริงไม่ถูกต้อง",
  ["actualTotalNoPackPaid" + TYPE_REQUIRED]: "จำนวนจ่ายจริง จำเป็นต้องกรอก",
  ["actualTotalNoPackPaid" + TYPE_MAX_VAL]:
    "จำนวนบรรจุภัณฑ์ที่จ่ายจริงสูงสุดคือ",
  ["actualTotalNoPackPaid" + TYPE_DECIMAL]: i18n.t(
    "business.actualTotalNumberOfPackagesPaid"
  ),
  ["actualTotalNoPackReceived" + TYPE_NUMERIC]: "รูปแบบจำนวนเก็บจริงไม่ถูกต้อง",
  ["actualTotalNoPackReceived" + TYPE_REQUIRED]: "จำนวนเก็บจริง จำเป็นต้องกรอก",
  ["actualTotalNoPackReceived" + TYPE_MAX_VAL]:
    "จำนวนบรรจุภัณฑ์ทั้งหมดที่ได้รับจริงสูงสุดคือ",
  ["actualTotalNoPackReceived" + TYPE_DECIMAL]: i18n.t(
    "business.actualTotalNumberOfPackagesReceived"
  ),
  ["lowerLimit" + TYPE_BETWEEN]: "อุณหภูมิเกินขีดจำกัดต่ำสุดไม่ถูกต้อง",
  ["upperLimit" + TYPE_BETWEEN]: "อุณหภูมิเกินขีดจำกัดสูงสุดไม่ถูกต้อง",
  ["farthestStore" + TYPE_REQUIRED]: "จำเป็นต้องกรอกรหัสร้านไกลสุด",
  ["routeCode" + TYPE_REQUIRED]: "จำเป็นต้องกรอกรหัสเส้นทาง",
  ["ext1" + TYPE_REQUIRED]: "จำเป็นต้องกรอกประเภทปลายทาง",
  ext4: "รูปแบบ preset line ไม่ถูกต้อง",
  ["itemType" + TYPE_REQUIRED]: "จำเป็นต้องกรอกประเภทสินค้า",
  ["itemType"]: "รูปแบบการกรอกประเภทสินค้าไม่ถูกต้อง",
  ["itemNumber" + TYPE_REQUIRED]: "จำเป็นต้องกรอกหมายเลขสินค้า",
  ["itemNumber" + TYPE_NUMERIC]: "รูปแบบการกรอกหมายเลขสินค้าไม่ถูกต้อง",
  ["keywords" + TYPE_MAX_CHARACTER]: "คีย์เวิร์ดต้องมีตัวอักษรไม่เกิน 10",
  ["description" + TYPE_MAX_CHARACTER]: "คำอธิบายต้องมีตัวอักษรไม่เกิน 200",
  ["keywords" + TYPE_REQUIRED]: "จำเป็นต้องระบุคีย์เวิร์ด",
  ["temperatureControlName" + TYPE_REQUIRED]: "จำเป็นต้องระบุประเภทอุณหภูมิ",
  ["name" + TYPE_REQUIRED]: "จำเป็นต้องระบุชื่อ",
  ["new_userName" + TYPE_REQUIRED]: "จำเป็นต้องระบุชื่อ",
  ["email" + TYPE_REQUIRED]: "จำเป็นต้องระบุอีเมล",
  ["cell phone" + TYPE_REQUIRED]: "จำเป็นต้องระบุโทรศัพท์มือถือ",
  ["paymentChannel" + TYPE_REQUIRED]: i18n.t("public.paymentChannel"),
  ["actualOrderPrice" + TYPE_REQUIRED]: i18n.t("public.actualOrderPrice"),
  ["actualOrderPrice" + TYPE_DECIMAL]: i18n.t("public.actualOrderPrice"),
  ["actualCurrency" + TYPE_REQUIRED]: i18n.t("public.actualCurrency"),
  ["itemCode" + TYPE_FORMAT]: "รูปแบบรหัสรายการไม่ถูกต้อง",
  ["itemName" + TYPE_FORMAT]: "รูปแบบชื่อรายการไม่ถูกต้อง",
  ["shortName" + TYPE_FORMAT]: "รูปแบบชื่อย่อไม่ถูกต้อง",
  ["remark" + TYPE_FORMAT]: "รูปแบบหมายเหตุไม่ถูกต้อง",
  
};
const customErrorMessage = {
  actualQuantityOfGoods: i18n.t("trackingActivity.actualNoOfItemPerPackage"),
  ["lowerLimit" + TYPE_BETWEEN]:
    "Invalid Maximum Temperature Control Lower Limit",
  ["upperLimit" + TYPE_BETWEEN]:
    "Invalid Maximum Temperature Control Upper Limit",
  ["new_userName"]: "Name",
  ["cell phone"]: "Cell Phone",
  targetPickupDate: "Origin Target Pick Up Date/Time",
  targetDeliveryTime: "Destination Target Delivery Date/Time",
};
const getThaiErrorMessage = (name, val) => {
  if (!customThaiErrorMessage[name]) return "";
  if (name.includes(TYPE_BETWEEN)) {
    return `${customThaiErrorMessage[name]} เริ่มตั้งแต่ ${val[0]} ถึง ${val[1]}`;
  } else if (name.includes(TYPE_MAX_VAL)) {
    return `${customThaiErrorMessage[name]} ${val}`;
  } else if (name.includes(TYPE_MIN_VAL)) {
    return `${customThaiErrorMessage[name]} ${val}`;
  } else if (name.includes(TYPE_DECIMAL)) {
    return customThaiErrorMessage[name] + "ไม่ถูกต้อง";
  } else if (name.includes(TYPE_MAX_CHARACTER)) {
    return customThaiErrorMessage[name];
  } else if (name.includes(TYPE_FORMAT)) {
    return customThaiErrorMessage[name];
  } else {
    return customThaiErrorMessage[name] || "";
  }
};
const formatNameToWords = {
  insuranceCoverage: "Value",
};
const dictionary = {
  cn: {
    messages: {
      required: () => "不能为空！",
      max: (name, length) => {
        return `不能超过${length}字符`;
      },
      min: (name, length) => {
        return `请输入${length}位以上字符`;
      },
      alpha_dash: () => "只能输入字母、数字或下划线!",
      alpha_num: () => "只能输入字母、数字!",
      alpha: () => "只能输入字母!",
      numeric: () => "请输入正整数!",
      max_value: (name, length) => {
        return `数字值不能超过${length}`;
      },
      min_value: (name, length) => {
        return `数字值不得低于${length}`;
      },
      email: () => "请输入正确的邮箱！",
      url: () => "请输入正确url地址！",
      regex: (name, val) => {
        switch (val[0].toString()) {
          case regexObj.isMobileNumber.toString():
            return `请输入正确电话号码`;
            break;
          case regexObj.isPositiveInteger.toString():
            return `请输入正整数`;
            break;
          case regexObj.isInteger.toString():
            return `请输入正整数`;
            break;
          case regexObj.isIdCardNumber.toString():
            return `请正确输入身份证号`;
            break;
          case regexObj.greaterZero.toString():
            return `请输入大于0的数字`;
            break;
          case regexObj.positiveIntegerZero.toString():
            return `请输入大于0的正整数`;
            break;
          case regexObj.isPositiveIntegerHasZero.toString():
            return `请输入大于等于0的正整数`;
            break;
          case regexObj.isFloatingPointNumbersHasZero.toString():
            return `请输入大于等于0的数字`;
            break;
          default:
            return `请输入正确格式!`;
        }
      },
      between: (name, val) => {
        return `请输入${val[0]}~${val[1]}之间数字`;
      },
      decimal: (name, val) => {
        return val.length > 0
          ? `只能输入小数点后${val[0]}位的小数或整数`
          : `只能输入小数或整数!`;
      },
      confirmed: (name, val, val2) => {
        return "两次输入不一致！";
      },
    },
  },
  en: {
    messages: {
      required: (name) =>
        `${
          customErrorMessage[name] ||
          validLabelObj[name] ||
          getFieldLabel(name) ||
          name ||
          "Field"
        } is required`,
      numeric: (name, val) => `Please enter integer number`,
      digits: (name, val) => `Invalid ${getFieldLabel(name)}`,
      max: (name, val) => `${errorMessageByName(name, val)}`,
      min: (name, val) => `Invalid ${getFieldLabel(name)}`,
      email: () => "Invalid Email",
      decimal: (name) => `${errorMessageByName(name)} `,
      min_value: (name, val) => `${getFieldLabel(name)} minimum is ${val}`,
      between: (name, val) =>
        `${
          customErrorMessage[name + TYPE_BETWEEN] ||
          errorMessageBetween(name, val)
        }`,
      max_value: (name, val) => `${getFieldLabel(name)} maximum is ${val}`,
      formatNumeric: (name, val) => `Incorrect ${getFieldLabel(name)} format`,
      commonInput: (name, val) => `Incorrect ${getFieldLabel(name)} format`,
      exceptSpecialCharactersv1: (name, val) => `Cannot input special character as commas (“ , “) or Slash ( “ / ” )`,
      exceptSpecialCharactersv2: (name, val) => `Cannot input special character as slash ( “ / ” )`,
      item_number_min_value: (name, val) =>
        `Incorrect ${getFieldLabel(name)} format`,
      max_character: (name, val) => `${errorMessageByName(name, val)}`,
      maxRemark: (name, val) => i18n.t("public.remarkLimitError", { n: val }),
    },
  },
  th: {
    messages: {
      required: (name) =>
        `${
          getThaiErrorMessage(name + TYPE_REQUIRED) ||
          validLabelObj[name] ||
          name
        }จำเป็นต้องกรอก`,
      numeric: (name) =>
        getThaiErrorMessage(name + TYPE_NUMERIC) || "กรุณากรอกเลขจำนวนเต็ม",
      max: (name, val) =>
        `${
          validLabelObj[name] || name
        }ระบุได้มากสุด ${val} ตัวอักษร หรือ น้อยกว่า`,
      max_value: (name, val) =>
        getThaiErrorMessage(name + TYPE_MAX_VAL, val) ||
        `${validLabelObj[name] || name}สูงสุดคือ ${val}`,
      min_value: (name, val) =>
        getThaiErrorMessage(name + TYPE_MIN_VAL, val) ||
        `${validLabelObj[name] || name}ต่ำสุด ${val}`,
      formatNumeric: (name, val) =>
        getThaiErrorMessage(name + TYPE_NUMERIC) ||
        `ไม่ถูกต้อง ${validLabelObj[name] || name} รูปแบบ`,
      decimal: (name) => getThaiErrorMessage(name + TYPE_DECIMAL),
      between: (name, val) =>
        getThaiErrorMessage(name + TYPE_BETWEEN, val) ||
        name + " เริ่มตั้งแต่ " + val[0] + " ถึง " + val[1],
      commonInput: (name, val) => getThaiErrorMessage(name + TYPE_FORMAT),
      item_number_min_value: (name, val) =>
        getThaiErrorMessage(name + TYPE_NUMERIC),
      max_character: (name, val) =>
        getThaiErrorMessage(name + TYPE_MAX_CHARACTER, val),
      extendCommonInput: (name, val) => getThaiErrorMessage(name),
      "valid-special-character": (name, val) =>
        `${getFieldLabel(name)}ไม่ถูกต้อง`,
      exceptSpecialCharactersv1: (name, val) => `ไม่สามารถใส่อักขระพิเศษเช่นจุลภาค (“ , “) หรือ ทับ ( “ / ” )`,
      exceptSpecialCharactersv2: (name, val) => `ไม่สามารถใส่อักขระพิเศษเช่นทับ (“ / “)`,
      maxRemark: (name, val) => i18n.t("public.remarkLimitError", { n: val }),
    },
  },
};

const getFieldLabel = (key, object = validLabelObj) => {
  //console.log("getFieldLabel: " + key)
  if (object[key]) {
    return object[key];
  }
  const text = key.match(/[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g);
  if (text && text.length) {
    return capitalizeFirstLetter(text.join(" "));
  }
  return key;
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const errorMessageBetween = (name, val) => {
  if (formatNameToWords[name]) {
    return `${formatNameToWords[name]} must be from ${val[0]} - ${val[1]}`;
  }
  return `Invalid ${getFieldLabel(name)}`;
};
const errorMessageByName = (name, val) => {
  //console.log("errorMessageByName: " + name)
  if (formatErrorMessagesDecimal[name]) {
    return formatErrorMessagesDecimal[name];
  }
  if (formatErrorMessagesMax[name]) {
    return `${formatErrorMessagesMax[name]} must be ${val} characters or fewer`;
  }
  if (formatErrorMessagesCharacter[name]) {
    return `${formatErrorMessagesCharacter[name]}`;
  }
  return `Invalid ${getFieldLabel(name)}`;
};
export { dictionary, regexObj, getFieldLabel };



// WEBPACK FOOTER //
// ./src/assets/js/common/veeValidate.js